import Space from "./space"

export default Space
